import { formatCliftonStrengths, formatRenumerationType, formatSectors } from '../../Functions/FormattedValues';
import { parseSector } from '../../Hooks/useSectorMigration';
import CreateTableContext from './TableContext';

const fields = [
    "mcb_roleid",
    "mcb_roletitle",
    "mcb_applicationstatus",
    "mcb_atriskrenumeration",
    "mcb_baserenumeration",
    "mcb_challenge",
    "mcb_companyname_",
    "mcb_cliftonstrength",
    "mcb_datesubmitted",
    "mcb_description",
    "mcb_starteddate",
    "mcb_endeddate",
    "mcb_generalcomments",
    "mcb_interestedcompany",
    "mcb_notinterestedcompany",
    "mcb_interestedsectors",
    "mcb_notinterestedsectors",
    "mcb_onboardingplan",
    "mcb_positiondescriptiondoc",
    "mcb_renumerationtype",
    "mcb_reportingto",
    "mcb_rolecompanyname",
    "mcb_rolehtml",
    // "mcb_rolelevel",
    "mcb_rolestatus",
    // "mcb_roletype",
    "mcb_sector",
    "mcb_rac", // this value is computed under MyRACCompute and MyIdealRoleCompute
    // "mcb_sectornamesummary",
    "mcb_updatedcv"
];

const relations = {
    "mcb_CoverLetter": "mcb_coverletter",
    "mcb_CV": "mcb_cv",
    "mcb_Person": "contact"
}

const expand = {
    "mcb_KeySkills": "mcb_skill",
    "mcb_CVRoles": "mcb_cv",
    "mcb_TertiaryQualifications": "mcb_qualification",
};

const readOnly = [
    "modifiedon",
    "createdon"
];
const formattedValues = {
    mcb_renumerationtype: formatRenumerationType,
    mcb_cliftonstrength: formatCliftonStrengths,
    mcb_interestedsectors: formatSectors,
    mcb_notinterestedsectors: formatSectors
};

const [useRole, RoleProvider] = CreateTableContext(
    "mcb_role", {
        contextName: "Role",
        preSubmission: (entity, profileData) => ({
            ...entity,
            mcb_datesubmitted: entity?.mcb_datesubmitted ? entity.mcb_datesubmitted : null,
            mcb_endeddate: entity?.mcb_endeddate ? entity.mcb_endeddate : null,
            mcb_starteddate: entity?.mcb_starteddate ? entity.mcb_starteddate : null,
            mcb_interestedsectors: parseSector(entity?.mcb_interestedsectors),
            mcb_notinterestedsectors: parseSector(entity?.mcb_notinterestedsectors),
            mcb_sector: parseSector(entity?.mcb_sector),
            _mcb_person_value: profileData?.id
        }), fields, readOnly, expand, relations,
        formattedValues
    }
);

export default useRole;
export { useRole, RoleProvider };
